import { Platform } from 'react-native';
import { MAP_MARKER_ICONS } from '../pantry/pantryIcon';
import { SiteSource } from '../../types/Site';

// Pin variants specific to the new site map -- not shared with the legacy PantryMap, which keeps
// using the original assets in pantryIcon.js's MAP_MARKER_ICONS.
const SITE_MARKER_ICONS =
  Platform.OS === 'web'
    ? {
        // eslint-disable-next-line global-require -- platform-conditional asset require, same pattern as pantryIcon.js
        active: require('../../assets/images/web-active_pin_small_new.png'),
        // eslint-disable-next-line global-require -- platform-conditional asset require, same pattern as pantryIcon.js
        freshtrak: require('../../assets/images/web-freshtrak_pin_small.png'),
      }
    : {
        // eslint-disable-next-line global-require -- platform-conditional asset require, same pattern as pantryIcon.js
        active: require('../../assets/images/mobile-native-active_pin_small_new.png'),
        // eslint-disable-next-line global-require -- platform-conditional asset require, same pattern as pantryIcon.js
        freshtrak: require('../../assets/images/mobile-native-freshtrak_pin_small.png'),
      };

/**
 * Returns the pin asset for a Site's source. A site with no source at all (or an unrecognized
 * source) gets the same "other pantry" pin as an imported site, rather than the platform's default
 * marker pin.
 */
function getSiteMarkerIcon(source: SiteSource | undefined, isSelected: boolean) {
  if (isSelected) return SITE_MARKER_ICONS.active;
  if (source === 'plentifulProvider') return MAP_MARKER_ICONS.inActive;
  if (source === 'freshtrak') return SITE_MARKER_ICONS.freshtrak;
  return MAP_MARKER_ICONS.otherPantry;
}

export default getSiteMarkerIcon;
